export const SET_USER_SEARCH_RESULT = "SET_USER_SEARCH_RESULT";
export const SET_SEARCH_TEXT = "SET_SEARCH_TEXT";
export const SET_EDIT_GROUP_MODEL_STATE = "SET_MODEL_STATE";
export const SET_EDIT_GROUP_NAME_TO_MEMBER_STATE =
  "SET_EDIT_GROUP_NAME_TO_MEMBER_STATE";
export const SET_PARTICIPANT_MODEL_STATE = "SET_PARTICIPANT_MODEL_STATE";
export const SET_QUOTE = "SET_QUOTE";
export const SET_SEEN = "SET_SEEN";
export const SET_NIGHT_MODE = "SET_NIGHT_MODE";
export const SET_ADMIN_PANEL = "SET_ADMIN_PANEL";
export const SET_SIDE_BAR = "SET_SIDE_BAR";
export const SET_RECEIVING_DATA = "SET_RECEIVING_DATA";
export const SET_CALLING_DATA = "SET_CALLING_DATA";
export const SET_REMOTE_STREAM = "SET_REMOTE_STREAM";
export const SET_LOCAL_STREAM = "SET_LOCAL_STREAM";
